import DataVLayouts from './layouts';
export default DataVLayouts;
